
import getApi from './api'
const getParams = (name) => {
  const urlSearch = window.location.search
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = urlSearch.substr(1).match(reg)
  console.log(urlSearch, r, 999999999999999999)
  if (r != null) return unescape(r[2]);
  return ''
}
if (getParams('token')) {
  sessionStorage.setItem('token', getParams('token'))
}

const fetchData = (config = {}, baseUrl =  '//api.ahgstyy.com/', customUrl = '') => {


  return (() => {
    return (apiName, data1 = {}, headData = {}, throttle = 500) => {
      const apiConfig = getApi(apiName)
      const data = data1
      // assign Data end
      if (!apiConfig) {
        console.log('接口未定义!', apiName)
        throw new TypeError('接口未定义!')
      }
      var [api, method, domainType] = apiConfig

      if (method === 'GET' && data) {
        let Uri
        api.indexOf('?') > -1 ? (Uri = '&') : (Uri = '?')
        Object.keys(data).forEach((key, indx) => {
          if (indx === data.length) {
            Uri = Uri + `${key}=${data[key]}`
          } else {
            Uri = Uri + `${key}=${data[key]}&`
          }
        })
        api = api + Uri
      }

      const headers = Object.assign(
        {
          'X-Access-Token': getParams('token') || sessionStorage.getItem('token'),
          from: 'js',
          'Content-Type': 'application/json'
        },
        headData
      )
      const option = {
        method, // *GET, POST, PUT, DELETE, etc.
        mode: 'cors',
        // credentials: 'include',
        headers: headers
      }

      if (method === 'POST') {
        option.body = JSON.stringify(data) // body data type must match "Content-Type" header
      }

      const vhallFetch = () =>
        fetch(baseUrl + api, option)
          .then(res => {
            if (res.ok) {
              return res.json()
            } else {
              // eslint-disable-next-line prefer-promise-reject-errors,no-undef
              reject('net work error')
            }
          })
          .then(res => {
            // 401 单点登录
            // if (res.code != 1) {
            //   Toast(res.msg || '网络开小差了！请刷新')
            // }
            return res
          })
      return vhallFetch()
    }
  })()
}

export default fetchData()



// WEBPACK FOOTER //
// ./src/api/index.js